import WhyChooseBullet from "../../assets/icons/why_choose_bullet_icon.svg"

interface WhyChooseProps {
    title: string;
    description: string;
}
const WhyChoosePoints: React.FC<WhyChooseProps> = ({
    title,
    description
}) => {
    return (
        <div className="flex items-start">
            <img src={WhyChooseBullet} alt="bullet" className="mt-5 mr-[16px]" />

            <div className="inline-block float-end">
                <h2 className="text-[24px] font-semibold leading-10">{title}</h2>
                <p className="opacity-75">{description}</p>
            </div>
        </div>
    )
}

export default WhyChoosePoints; 